// Generated by scripts/sync-printful-mockups.mjs. Do not hand-edit.
export const GENERATED_POD_SPECS = {
  "scorpion-chest-tee": {
    "productId": 71,
    "productName": "Unisex Staple T-Shirt | Bella + Canvas 3001",
    "size": "M",
    "technique": "DTG",
    "productType": "tee",
    "slug": "scorpion-chest-tee",
    "variantId": 4012,
    "color": "White",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "file": "scorpion-main.png",
    "mascot": "scorpion",
    "realPhoto": "/products/scorpion-chest-real.webp",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 3001 Unisex Short Sleeve Jersey T-Shirt with Tear Away Label (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-back-tee": {
    "productId": 71,
    "productName": "Unisex Staple T-Shirt | Bella + Canvas 3001",
    "size": "M",
    "technique": "DTG",
    "productType": "tee",
    "slug": "scorpion-back-tee",
    "variantId": 4012,
    "color": "White",
    "placement": "back",
    "view": "back",
    "layout": "back_large",
    "file": "scorpion-main.png",
    "mascot": "scorpion",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 3001 Unisex Short Sleeve Jersey T-Shirt with Tear Away Label (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-hem-tee": {
    "productId": 71,
    "productName": "Unisex Staple T-Shirt | Bella + Canvas 3001",
    "size": "M",
    "technique": "DTG",
    "productType": "tee",
    "slug": "jellyfish-hem-tee",
    "variantId": 4012,
    "color": "White",
    "placement": "front",
    "view": "front",
    "layout": "lower_right",
    "file": "jellyfish.png",
    "mascot": "jellyfish",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 3001 Unisex Short Sleeve Jersey T-Shirt with Tear Away Label (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "snake-chest-tee": {
    "productId": 71,
    "productName": "Unisex Staple T-Shirt | Bella + Canvas 3001",
    "size": "M",
    "technique": "DTG",
    "productType": "tee",
    "slug": "snake-chest-tee",
    "variantId": 4017,
    "color": "Black",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "file": "snake.png",
    "mascot": "snake",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 3001 Unisex Short Sleeve Jersey T-Shirt with Tear Away Label (Black / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      }
    ]
  },
  "snake-back-tee": {
    "productId": 71,
    "productName": "Unisex Staple T-Shirt | Bella + Canvas 3001",
    "size": "M",
    "technique": "DTG",
    "productType": "tee",
    "slug": "snake-back-tee",
    "variantId": 4017,
    "color": "Black",
    "placement": "back",
    "view": "back",
    "layout": "back_large",
    "file": "snake.png",
    "mascot": "snake",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 3001 Unisex Short Sleeve Jersey T-Shirt with Tear Away Label (Black / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      }
    ]
  },
  "puffer-mug": {
    "slug": "puffer-mug",
    "productId": 19,
    "productName": "White Glossy Mug",
    "variantId": 1320,
    "color": "White",
    "size": "11 oz",
    "technique": "SUBLIMATION",
    "productType": "mug",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "file": "puffer.png",
    "mascot": "puffer",
    "realPhoto": "/products/puffer-mug-real.webp",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "White Glossy Mug 11 oz",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      },
      {
        "region": "BR",
        "status": "in_stock"
      }
    ]
  },
  "snake-tumbler": {
    "slug": "snake-tumbler",
    "productId": 585,
    "productName": "Stainless Steel Tumbler",
    "variantId": 15005,
    "color": "White",
    "size": "20 oz",
    "technique": "UV",
    "productType": "tumbler",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "file": "snake.png",
    "mascot": "snake",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Stainless Steel Tumbler (White / 20 oz)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-unisex-v-neck-tee-223": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-unisex-v-neck-tee-223",
    "name": "SCORPION UNISEX V-NECK TEE",
    "productId": 223,
    "productName": "Unisex V-Neck Tee | Bella + Canvas 3005",
    "variantId": 8025,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 3005 Unisex Short Sleeve V-Neck Jersey Tee with Tear Away Label (White/M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "snake-unisex-v-neck-tee-223": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-unisex-v-neck-tee-223",
    "name": "SNAKE UNISEX V-NECK TEE",
    "productId": 223,
    "productName": "Unisex V-Neck Tee | Bella + Canvas 3005",
    "variantId": 8025,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 3005 Unisex Short Sleeve V-Neck Jersey Tee with Tear Away Label (White/M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-unisex-v-neck-tee-223": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-unisex-v-neck-tee-223",
    "name": "JELLYFISH UNISEX V-NECK TEE",
    "productId": 223,
    "productName": "Unisex V-Neck Tee | Bella + Canvas 3005",
    "variantId": 8025,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 3005 Unisex Short Sleeve V-Neck Jersey Tee with Tear Away Label (White/M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "puffer-unisex-v-neck-tee-223": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-unisex-v-neck-tee-223",
    "name": "PUFFER UNISEX V-NECK TEE",
    "productId": 223,
    "productName": "Unisex V-Neck Tee | Bella + Canvas 3005",
    "variantId": 8025,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 3005 Unisex Short Sleeve V-Neck Jersey Tee with Tear Away Label (White/M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-unisex-long-sleeve-tee-356": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-unisex-long-sleeve-tee-356",
    "name": "SCORPION UNISEX LONG SLEEVE TEE",
    "productId": 356,
    "productName": "Unisex Long Sleeve Tee | Bella + Canvas 3501",
    "variantId": 10143,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 3501 Unisex Long Sleeve Shirt (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "snake-unisex-long-sleeve-tee-356": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-unisex-long-sleeve-tee-356",
    "name": "SNAKE UNISEX LONG SLEEVE TEE",
    "productId": 356,
    "productName": "Unisex Long Sleeve Tee | Bella + Canvas 3501",
    "variantId": 10143,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 3501 Unisex Long Sleeve Shirt (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-unisex-long-sleeve-tee-356": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-unisex-long-sleeve-tee-356",
    "name": "JELLYFISH UNISEX LONG SLEEVE TEE",
    "productId": 356,
    "productName": "Unisex Long Sleeve Tee | Bella + Canvas 3501",
    "variantId": 10143,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 3501 Unisex Long Sleeve Shirt (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "puffer-unisex-long-sleeve-tee-356": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-unisex-long-sleeve-tee-356",
    "name": "PUFFER UNISEX LONG SLEEVE TEE",
    "productId": 356,
    "productName": "Unisex Long Sleeve Tee | Bella + Canvas 3501",
    "variantId": 10143,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 3501 Unisex Long Sleeve Shirt (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-men-s-premium-heavyweight-tee-508": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-men-s-premium-heavyweight-tee-508",
    "name": "SCORPION MEN'S PREMIUM HEAVYWEIGHT TEE",
    "productId": 508,
    "productName": "Men's Premium Heavyweight Tee | Cotton Heritage MC1086",
    "variantId": 12762,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Cotton Heritage MC1086 Men's Premium Heavyweight Tee (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      }
    ]
  },
  "snake-men-s-premium-heavyweight-tee-508": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-men-s-premium-heavyweight-tee-508",
    "name": "SNAKE MEN'S PREMIUM HEAVYWEIGHT TEE",
    "productId": 508,
    "productName": "Men's Premium Heavyweight Tee | Cotton Heritage MC1086",
    "variantId": 12762,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Cotton Heritage MC1086 Men's Premium Heavyweight Tee (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-men-s-premium-heavyweight-tee-508": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-men-s-premium-heavyweight-tee-508",
    "name": "JELLYFISH MEN'S PREMIUM HEAVYWEIGHT TEE",
    "productId": 508,
    "productName": "Men's Premium Heavyweight Tee | Cotton Heritage MC1086",
    "variantId": 12762,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Cotton Heritage MC1086 Men's Premium Heavyweight Tee (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      }
    ]
  },
  "puffer-men-s-premium-heavyweight-tee-508": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-men-s-premium-heavyweight-tee-508",
    "name": "PUFFER MEN'S PREMIUM HEAVYWEIGHT TEE",
    "productId": 508,
    "productName": "Men's Premium Heavyweight Tee | Cotton Heritage MC1086",
    "variantId": 12762,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Cotton Heritage MC1086 Men's Premium Heavyweight Tee (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-women-s-relaxed-t-shirt-360": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-women-s-relaxed-t-shirt-360",
    "name": "SCORPION WOMEN'S RELAXED T-SHIRT",
    "productId": 360,
    "productName": "Women's Relaxed T-Shirt | Bella + Canvas 6400",
    "variantId": 10253,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 6400 Women's Relaxed Short Sleeve Jersey Tee (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "snake-women-s-relaxed-t-shirt-360": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-women-s-relaxed-t-shirt-360",
    "name": "SNAKE WOMEN'S RELAXED T-SHIRT",
    "productId": 360,
    "productName": "Women's Relaxed T-Shirt | Bella + Canvas 6400",
    "variantId": 10253,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 6400 Women's Relaxed Short Sleeve Jersey Tee (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-women-s-relaxed-t-shirt-360": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-women-s-relaxed-t-shirt-360",
    "name": "JELLYFISH WOMEN'S RELAXED T-SHIRT",
    "productId": 360,
    "productName": "Women's Relaxed T-Shirt | Bella + Canvas 6400",
    "variantId": 10253,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 6400 Women's Relaxed Short Sleeve Jersey Tee (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "puffer-women-s-relaxed-t-shirt-360": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-women-s-relaxed-t-shirt-360",
    "name": "PUFFER WOMEN'S RELAXED T-SHIRT",
    "productId": 360,
    "productName": "Women's Relaxed T-Shirt | Bella + Canvas 6400",
    "variantId": 10253,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Bella + Canvas 6400 Women's Relaxed Short Sleeve Jersey Tee (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-unisex-premium-sweatshirt-411": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-unisex-premium-sweatshirt-411",
    "name": "SCORPION UNISEX PREMIUM SWEATSHIRT",
    "productId": 411,
    "productName": "Unisex Premium Sweatshirt | Cotton Heritage M2480",
    "variantId": 11250,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Cotton Heritage M2480 (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "snake-unisex-premium-sweatshirt-411": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-unisex-premium-sweatshirt-411",
    "name": "SNAKE UNISEX PREMIUM SWEATSHIRT",
    "productId": 411,
    "productName": "Unisex Premium Sweatshirt | Cotton Heritage M2480",
    "variantId": 11250,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Cotton Heritage M2480 (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-unisex-premium-sweatshirt-411": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-unisex-premium-sweatshirt-411",
    "name": "JELLYFISH UNISEX PREMIUM SWEATSHIRT",
    "productId": 411,
    "productName": "Unisex Premium Sweatshirt | Cotton Heritage M2480",
    "variantId": 11250,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Cotton Heritage M2480 (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "puffer-unisex-premium-sweatshirt-411": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-unisex-premium-sweatshirt-411",
    "name": "PUFFER UNISEX PREMIUM SWEATSHIRT",
    "productId": 411,
    "productName": "Unisex Premium Sweatshirt | Cotton Heritage M2480",
    "variantId": 11250,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Cotton Heritage M2480 (White / M)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-eco-tote-bag-367": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-eco-tote-bag-367",
    "name": "SCORPION ECO TOTE BAG",
    "productId": 367,
    "productName": "Eco Tote Bag | Econscious EC8000",
    "variantId": 10457,
    "color": "Black",
    "size": "One size",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Econscious EC8000 Organic Cotton Tote Bag (Black / One size)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "snake-eco-tote-bag-367": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-eco-tote-bag-367",
    "name": "SNAKE ECO TOTE BAG",
    "productId": 367,
    "productName": "Eco Tote Bag | Econscious EC8000",
    "variantId": 10457,
    "color": "Black",
    "size": "One size",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Econscious EC8000 Organic Cotton Tote Bag (Black / One size)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-eco-tote-bag-367": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-eco-tote-bag-367",
    "name": "JELLYFISH ECO TOTE BAG",
    "productId": 367,
    "productName": "Eco Tote Bag | Econscious EC8000",
    "variantId": 10457,
    "color": "Black",
    "size": "One size",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Econscious EC8000 Organic Cotton Tote Bag (Black / One size)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "puffer-eco-tote-bag-367": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-eco-tote-bag-367",
    "name": "PUFFER ECO TOTE BAG",
    "productId": 367,
    "productName": "Eco Tote Bag | Econscious EC8000",
    "variantId": 10457,
    "color": "Black",
    "size": "One size",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Econscious EC8000 Organic Cotton Tote Bag (Black / One size)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-white-ceramic-mug-with-color-inside-403": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-white-ceramic-mug-with-color-inside-403",
    "name": "SCORPION WHITE CERAMIC MUG WITH COLOR INSIDE",
    "productId": 403,
    "productName": "White Ceramic Mug with Color Inside",
    "variantId": 11051,
    "color": "Black",
    "size": "11 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Ceramic Mug with Color Inside (Black / 11 oz)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "snake-white-ceramic-mug-with-color-inside-403": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-white-ceramic-mug-with-color-inside-403",
    "name": "SNAKE WHITE CERAMIC MUG WITH COLOR INSIDE",
    "productId": 403,
    "productName": "White Ceramic Mug with Color Inside",
    "variantId": 11051,
    "color": "Black",
    "size": "11 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Ceramic Mug with Color Inside (Black / 11 oz)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-white-ceramic-mug-with-color-inside-403": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-white-ceramic-mug-with-color-inside-403",
    "name": "JELLYFISH WHITE CERAMIC MUG WITH COLOR INSIDE",
    "productId": 403,
    "productName": "White Ceramic Mug with Color Inside",
    "variantId": 11051,
    "color": "Black",
    "size": "11 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Ceramic Mug with Color Inside (Black / 11 oz)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "puffer-white-ceramic-mug-with-color-inside-403": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-white-ceramic-mug-with-color-inside-403",
    "name": "PUFFER WHITE CERAMIC MUG WITH COLOR INSIDE",
    "productId": 403,
    "productName": "White Ceramic Mug with Color Inside",
    "variantId": 11051,
    "color": "Black",
    "size": "11 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Ceramic Mug with Color Inside (Black / 11 oz)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-enamel-mug-407": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-enamel-mug-407",
    "name": "SCORPION ENAMEL MUG",
    "productId": 407,
    "productName": "Enamel Mug",
    "variantId": 11189,
    "color": "White",
    "size": "12 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Enamel Mug (White / 12 oz)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "snake-enamel-mug-407": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-enamel-mug-407",
    "name": "SNAKE ENAMEL MUG",
    "productId": 407,
    "productName": "Enamel Mug",
    "variantId": 11189,
    "color": "White",
    "size": "12 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Enamel Mug (White / 12 oz)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-enamel-mug-407": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-enamel-mug-407",
    "name": "JELLYFISH ENAMEL MUG",
    "productId": 407,
    "productName": "Enamel Mug",
    "variantId": 11189,
    "color": "White",
    "size": "12 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Enamel Mug (White / 12 oz)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "puffer-enamel-mug-407": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-enamel-mug-407",
    "name": "PUFFER ENAMEL MUG",
    "productId": 407,
    "productName": "Enamel Mug",
    "variantId": 11189,
    "color": "White",
    "size": "12 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Enamel Mug (White / 12 oz)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-insulated-tumbler-with-a-straw-742": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-insulated-tumbler-with-a-straw-742",
    "name": "SCORPION INSULATED TUMBLER WITH A STRAW",
    "productId": 742,
    "productName": "Insulated Tumbler with a Straw",
    "variantId": 19111,
    "color": "White",
    "size": "20 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Insulated Tumbler with a Straw (White / 20 oz)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "snake-insulated-tumbler-with-a-straw-742": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-insulated-tumbler-with-a-straw-742",
    "name": "SNAKE INSULATED TUMBLER WITH A STRAW",
    "productId": 742,
    "productName": "Insulated Tumbler with a Straw",
    "variantId": 19111,
    "color": "White",
    "size": "20 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Insulated Tumbler with a Straw (White / 20 oz)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-insulated-tumbler-with-a-straw-742": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-insulated-tumbler-with-a-straw-742",
    "name": "JELLYFISH INSULATED TUMBLER WITH A STRAW",
    "productId": 742,
    "productName": "Insulated Tumbler with a Straw",
    "variantId": 19111,
    "color": "White",
    "size": "20 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Insulated Tumbler with a Straw (White / 20 oz)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "puffer-insulated-tumbler-with-a-straw-742": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-insulated-tumbler-with-a-straw-742",
    "name": "PUFFER INSULATED TUMBLER WITH A STRAW",
    "productId": 742,
    "productName": "Insulated Tumbler with a Straw",
    "variantId": 19111,
    "color": "White",
    "size": "20 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Insulated Tumbler with a Straw (White / 20 oz)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-stainless-steel-water-bottle-382": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-stainless-steel-water-bottle-382",
    "name": "SCORPION STAINLESS STEEL WATER BOTTLE",
    "productId": 382,
    "productName": "Stainless Steel Water Bottle",
    "variantId": 10798,
    "color": "White",
    "size": "17 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Stainless Steel Water Bottle 17 oz",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "snake-stainless-steel-water-bottle-382": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-stainless-steel-water-bottle-382",
    "name": "SNAKE STAINLESS STEEL WATER BOTTLE",
    "productId": 382,
    "productName": "Stainless Steel Water Bottle",
    "variantId": 10798,
    "color": "White",
    "size": "17 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Stainless Steel Water Bottle 17 oz",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-stainless-steel-water-bottle-382": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-stainless-steel-water-bottle-382",
    "name": "JELLYFISH STAINLESS STEEL WATER BOTTLE",
    "productId": 382,
    "productName": "Stainless Steel Water Bottle",
    "variantId": 10798,
    "color": "White",
    "size": "17 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Stainless Steel Water Bottle 17 oz",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "puffer-stainless-steel-water-bottle-382": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-stainless-steel-water-bottle-382",
    "name": "PUFFER STAINLESS STEEL WATER BOTTLE",
    "productId": 382,
    "productName": "Stainless Steel Water Bottle",
    "variantId": 10798,
    "color": "White",
    "size": "17 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Stainless Steel Water Bottle 17 oz",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-wine-tumbler-632": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-wine-tumbler-632",
    "name": "SCORPION WINE TUMBLER",
    "productId": 632,
    "productName": "Wine Tumbler",
    "variantId": 16046,
    "color": "White",
    "size": "12 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Wine Tumbler (White / 12 oz)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "snake-wine-tumbler-632": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-wine-tumbler-632",
    "name": "SNAKE WINE TUMBLER",
    "productId": 632,
    "productName": "Wine Tumbler",
    "variantId": 16046,
    "color": "White",
    "size": "12 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Wine Tumbler (White / 12 oz)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-wine-tumbler-632": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-wine-tumbler-632",
    "name": "JELLYFISH WINE TUMBLER",
    "productId": 632,
    "productName": "Wine Tumbler",
    "variantId": 16046,
    "color": "White",
    "size": "12 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Wine Tumbler (White / 12 oz)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "puffer-wine-tumbler-632": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-wine-tumbler-632",
    "name": "PUFFER WINE TUMBLER",
    "productId": 632,
    "productName": "Wine Tumbler",
    "variantId": 16046,
    "color": "White",
    "size": "12 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Wine Tumbler (White / 12 oz)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-cork-back-coaster-611": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-cork-back-coaster-611",
    "name": "SCORPION CORK-BACK COASTER",
    "productId": 611,
    "productName": "Cork-Back Coaster",
    "variantId": 15662,
    "color": "",
    "size": "3.74″×3.74″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Cork Back Coaster (3.74″×3.74″)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "snake-cork-back-coaster-611": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-cork-back-coaster-611",
    "name": "SNAKE CORK-BACK COASTER",
    "productId": 611,
    "productName": "Cork-Back Coaster",
    "variantId": 15662,
    "color": "",
    "size": "3.74″×3.74″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Cork Back Coaster (3.74″×3.74″)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-cork-back-coaster-611": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-cork-back-coaster-611",
    "name": "JELLYFISH CORK-BACK COASTER",
    "productId": 611,
    "productName": "Cork-Back Coaster",
    "variantId": 15662,
    "color": "",
    "size": "3.74″×3.74″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Cork Back Coaster (3.74″×3.74″)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "puffer-cork-back-coaster-611": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-cork-back-coaster-611",
    "name": "PUFFER CORK-BACK COASTER",
    "productId": 611,
    "productName": "Cork-Back Coaster",
    "variantId": 15662,
    "color": "",
    "size": "3.74″×3.74″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Cork Back Coaster (3.74″×3.74″)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-gaming-mouse-pad-583": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-gaming-mouse-pad-583",
    "name": "SCORPION GAMING MOUSE PAD",
    "productId": 583,
    "productName": "Gaming Mouse Pad",
    "variantId": 14942,
    "color": "White",
    "size": "36″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Gaming Mouse Pad (White / 36″×18″)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "snake-gaming-mouse-pad-583": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-gaming-mouse-pad-583",
    "name": "SNAKE GAMING MOUSE PAD",
    "productId": 583,
    "productName": "Gaming Mouse Pad",
    "variantId": 14942,
    "color": "White",
    "size": "36″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Gaming Mouse Pad (White / 36″×18″)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-gaming-mouse-pad-583": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-gaming-mouse-pad-583",
    "name": "JELLYFISH GAMING MOUSE PAD",
    "productId": 583,
    "productName": "Gaming Mouse Pad",
    "variantId": 14942,
    "color": "White",
    "size": "36″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Gaming Mouse Pad (White / 36″×18″)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "puffer-gaming-mouse-pad-583": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-gaming-mouse-pad-583",
    "name": "PUFFER GAMING MOUSE PAD",
    "productId": 583,
    "productName": "Gaming Mouse Pad",
    "variantId": 14942,
    "color": "White",
    "size": "36″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Gaming Mouse Pad (White / 36″×18″)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-desk-mat-853": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-desk-mat-853",
    "name": "SCORPION DESK MAT",
    "productId": 853,
    "productName": "Desk Mat",
    "variantId": 22325,
    "color": "Black",
    "size": "12″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Desk Mat (Black / 12″×18″)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "snake-desk-mat-853": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-desk-mat-853",
    "name": "SNAKE DESK MAT",
    "productId": 853,
    "productName": "Desk Mat",
    "variantId": 22325,
    "color": "Black",
    "size": "12″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Desk Mat (Black / 12″×18″)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-desk-mat-853": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-desk-mat-853",
    "name": "JELLYFISH DESK MAT",
    "productId": 853,
    "productName": "Desk Mat",
    "variantId": 22325,
    "color": "Black",
    "size": "12″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Desk Mat (Black / 12″×18″)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "puffer-desk-mat-853": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-desk-mat-853",
    "name": "PUFFER DESK MAT",
    "productId": 853,
    "productName": "Desk Mat",
    "variantId": 22325,
    "color": "Black",
    "size": "12″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Desk Mat (Black / 12″×18″)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-laptop-sleeve-394": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-laptop-sleeve-394",
    "name": "SCORPION LAPTOP SLEEVE",
    "productId": 394,
    "productName": "Laptop Sleeve",
    "variantId": 10984,
    "color": "",
    "size": "13″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Laptop Sleeve 13″",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "snake-laptop-sleeve-394": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-laptop-sleeve-394",
    "name": "SNAKE LAPTOP SLEEVE",
    "productId": 394,
    "productName": "Laptop Sleeve",
    "variantId": 10984,
    "color": "",
    "size": "13″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Laptop Sleeve 13″",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-laptop-sleeve-394": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-laptop-sleeve-394",
    "name": "JELLYFISH LAPTOP SLEEVE",
    "productId": 394,
    "productName": "Laptop Sleeve",
    "variantId": 10984,
    "color": "",
    "size": "13″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Laptop Sleeve 13″",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "puffer-laptop-sleeve-394": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-laptop-sleeve-394",
    "name": "PUFFER LAPTOP SLEEVE",
    "productId": 394,
    "productName": "Laptop Sleeve",
    "variantId": 10984,
    "color": "",
    "size": "13″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Laptop Sleeve 13″",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-throw-blanket-395": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-throw-blanket-395",
    "name": "SCORPION THROW BLANKET",
    "productId": 395,
    "productName": "Throw Blanket",
    "variantId": 10986,
    "color": "",
    "size": "50″×60″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Throw blanket 50″×60″",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "snake-throw-blanket-395": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-throw-blanket-395",
    "name": "SNAKE THROW BLANKET",
    "productId": 395,
    "productName": "Throw Blanket",
    "variantId": 10986,
    "color": "",
    "size": "50″×60″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Throw blanket 50″×60″",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-throw-blanket-395": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-throw-blanket-395",
    "name": "JELLYFISH THROW BLANKET",
    "productId": 395,
    "productName": "Throw Blanket",
    "variantId": 10986,
    "color": "",
    "size": "50″×60″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Throw blanket 50″×60″",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "puffer-throw-blanket-395": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-throw-blanket-395",
    "name": "PUFFER THROW BLANKET",
    "productId": 395,
    "productName": "Throw Blanket",
    "variantId": 10986,
    "color": "",
    "size": "50″×60″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Throw blanket 50″×60″",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-ruled-line-spiral-notebook-946": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-ruled-line-spiral-notebook-946",
    "name": "SCORPION RULED LINE SPIRAL NOTEBOOK",
    "productId": 946,
    "productName": "Ruled Line Spiral Notebook",
    "variantId": 24305,
    "color": "",
    "size": "One size",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Generic brand (One Size)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "snake-ruled-line-spiral-notebook-946": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-ruled-line-spiral-notebook-946",
    "name": "SNAKE RULED LINE SPIRAL NOTEBOOK",
    "productId": 946,
    "productName": "Ruled Line Spiral Notebook",
    "variantId": 24305,
    "color": "",
    "size": "One size",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Generic brand (One Size)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-ruled-line-spiral-notebook-946": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-ruled-line-spiral-notebook-946",
    "name": "JELLYFISH RULED LINE SPIRAL NOTEBOOK",
    "productId": 946,
    "productName": "Ruled Line Spiral Notebook",
    "variantId": 24305,
    "color": "",
    "size": "One size",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Generic brand (One Size)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "puffer-ruled-line-spiral-notebook-946": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-ruled-line-spiral-notebook-946",
    "name": "PUFFER RULED LINE SPIRAL NOTEBOOK",
    "productId": 946,
    "productName": "Ruled Line Spiral Notebook",
    "variantId": 24305,
    "color": "",
    "size": "One size",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Generic brand (One Size)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-enhanced-matte-paper-poster-in-1": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-enhanced-matte-paper-poster-in-1",
    "name": "SCORPION ENHANCED MATTE PAPER POSTER (IN)",
    "productId": 1,
    "productName": "Enhanced Matte Paper Poster (in)",
    "variantId": 1,
    "color": "",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Enhanced Matte Paper Poster 18″×24″",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "snake-enhanced-matte-paper-poster-in-1": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-enhanced-matte-paper-poster-in-1",
    "name": "SNAKE ENHANCED MATTE PAPER POSTER (IN)",
    "productId": 1,
    "productName": "Enhanced Matte Paper Poster (in)",
    "variantId": 1,
    "color": "",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Enhanced Matte Paper Poster 18″×24″",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-enhanced-matte-paper-poster-in-1": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-enhanced-matte-paper-poster-in-1",
    "name": "JELLYFISH ENHANCED MATTE PAPER POSTER (IN)",
    "productId": 1,
    "productName": "Enhanced Matte Paper Poster (in)",
    "variantId": 1,
    "color": "",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Enhanced Matte Paper Poster 18″×24″",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "puffer-enhanced-matte-paper-poster-in-1": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-enhanced-matte-paper-poster-in-1",
    "name": "PUFFER ENHANCED MATTE PAPER POSTER (IN)",
    "productId": 1,
    "productName": "Enhanced Matte Paper Poster (in)",
    "variantId": 1,
    "color": "",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Enhanced Matte Paper Poster 18″×24″",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "EU_ES",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-enhanced-matte-paper-framed-poster-in-2": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-enhanced-matte-paper-framed-poster-in-2",
    "name": "SCORPION ENHANCED MATTE PAPER FRAMED POSTER (IN)",
    "productId": 2,
    "productName": "Enhanced Matte Paper Framed Poster (in)",
    "variantId": 10749,
    "color": "White",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Enhanced Matte Paper Framed Poster (White/18″×24″)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "snake-enhanced-matte-paper-framed-poster-in-2": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-enhanced-matte-paper-framed-poster-in-2",
    "name": "SNAKE ENHANCED MATTE PAPER FRAMED POSTER (IN)",
    "productId": 2,
    "productName": "Enhanced Matte Paper Framed Poster (in)",
    "variantId": 10749,
    "color": "White",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Enhanced Matte Paper Framed Poster (White/18″×24″)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-enhanced-matte-paper-framed-poster-in-2": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-enhanced-matte-paper-framed-poster-in-2",
    "name": "JELLYFISH ENHANCED MATTE PAPER FRAMED POSTER (IN)",
    "productId": 2,
    "productName": "Enhanced Matte Paper Framed Poster (in)",
    "variantId": 10749,
    "color": "White",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Enhanced Matte Paper Framed Poster (White/18″×24″)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "puffer-enhanced-matte-paper-framed-poster-in-2": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-enhanced-matte-paper-framed-poster-in-2",
    "name": "PUFFER ENHANCED MATTE PAPER FRAMED POSTER (IN)",
    "productId": 2,
    "productName": "Enhanced Matte Paper Framed Poster (in)",
    "variantId": 10749,
    "color": "White",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Enhanced Matte Paper Framed Poster (White/18″×24″)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-magsafe-tough-case-for-iphone-798": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-magsafe-tough-case-for-iphone-798",
    "name": "SCORPION MAGSAFE TOUGH CASE FOR IPHONE®",
    "productId": 798,
    "productName": "MagSafe Tough Case for iPhone®",
    "variantId": 20318,
    "color": "Matte",
    "size": "iPhone 15",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "MagSafe® Tough Case for iPhone® (Matte / iPhone 15)",
    "availability": [
      {
        "region": "AU",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      }
    ]
  },
  "snake-magsafe-tough-case-for-iphone-798": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-magsafe-tough-case-for-iphone-798",
    "name": "SNAKE MAGSAFE TOUGH CASE FOR IPHONE®",
    "productId": 798,
    "productName": "MagSafe Tough Case for iPhone®",
    "variantId": 20318,
    "color": "Matte",
    "size": "iPhone 15",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "MagSafe® Tough Case for iPhone® (Matte / iPhone 15)",
    "availability": [
      {
        "region": "AU",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-magsafe-tough-case-for-iphone-798": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-magsafe-tough-case-for-iphone-798",
    "name": "JELLYFISH MAGSAFE TOUGH CASE FOR IPHONE®",
    "productId": 798,
    "productName": "MagSafe Tough Case for iPhone®",
    "variantId": 20318,
    "color": "Matte",
    "size": "iPhone 15",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "MagSafe® Tough Case for iPhone® (Matte / iPhone 15)",
    "availability": [
      {
        "region": "AU",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      }
    ]
  },
  "puffer-magsafe-tough-case-for-iphone-798": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-magsafe-tough-case-for-iphone-798",
    "name": "PUFFER MAGSAFE TOUGH CASE FOR IPHONE®",
    "productId": 798,
    "productName": "MagSafe Tough Case for iPhone®",
    "variantId": 20318,
    "color": "Matte",
    "size": "iPhone 15",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "MagSafe® Tough Case for iPhone® (Matte / iPhone 15)",
    "availability": [
      {
        "region": "AU",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-greeting-card-568": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-greeting-card-568",
    "name": "SCORPION GREETING CARD",
    "productId": 568,
    "productName": "Greeting Card",
    "variantId": 14457,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Greeting Card (4″×6″)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "snake-greeting-card-568": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-greeting-card-568",
    "name": "SNAKE GREETING CARD",
    "productId": 568,
    "productName": "Greeting Card",
    "variantId": 14457,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Greeting Card (4″×6″)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-greeting-card-568": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-greeting-card-568",
    "name": "JELLYFISH GREETING CARD",
    "productId": 568,
    "productName": "Greeting Card",
    "variantId": 14457,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Greeting Card (4″×6″)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "puffer-greeting-card-568": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-greeting-card-568",
    "name": "PUFFER GREETING CARD",
    "productId": 568,
    "productName": "Greeting Card",
    "variantId": 14457,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Greeting Card (4″×6″)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-standard-postcard-433": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-standard-postcard-433",
    "name": "SCORPION STANDARD POSTCARD",
    "productId": 433,
    "productName": "Standard Postcard",
    "variantId": 11513,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Standard Postcards (4″×6″)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "snake-standard-postcard-433": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-standard-postcard-433",
    "name": "SNAKE STANDARD POSTCARD",
    "productId": 433,
    "productName": "Standard Postcard",
    "variantId": 11513,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Standard Postcards (4″×6″)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-standard-postcard-433": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-standard-postcard-433",
    "name": "JELLYFISH STANDARD POSTCARD",
    "productId": 433,
    "productName": "Standard Postcard",
    "variantId": 11513,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Standard Postcards (4″×6″)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "puffer-standard-postcard-433": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-standard-postcard-433",
    "name": "PUFFER STANDARD POSTCARD",
    "productId": 433,
    "productName": "Standard Postcard",
    "variantId": 11513,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Standard Postcards (4″×6″)",
    "availability": [
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      },
      {
        "region": "US",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-kiss-cut-stickers-358": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-kiss-cut-stickers-358",
    "name": "SCORPION KISS-CUT STICKERS",
    "productId": 358,
    "productName": "Kiss-Cut Stickers",
    "variantId": 10163,
    "color": "White",
    "size": "3″×3″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Kiss Cut Stickers (3″×3″in)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "snake-kiss-cut-stickers-358": {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-kiss-cut-stickers-358",
    "name": "SNAKE KISS-CUT STICKERS",
    "productId": 358,
    "productName": "Kiss-Cut Stickers",
    "variantId": 10163,
    "color": "White",
    "size": "3″×3″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/snake.png",
      "url": "https://paralyze-area.vercel.app/print-files/snake.png",
      "width": 3000,
      "height": 3000,
      "sha256": "51695c69d5f3e3b9c5c5fef1fb36459a12dd6370e36195743c0eedcda2efc164"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Kiss Cut Stickers (3″×3″in)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "jellyfish-kiss-cut-stickers-358": {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-kiss-cut-stickers-358",
    "name": "JELLYFISH KISS-CUT STICKERS",
    "productId": 358,
    "productName": "Kiss-Cut Stickers",
    "variantId": 10163,
    "color": "White",
    "size": "3″×3″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/jellyfish.png",
      "url": "https://paralyze-area.vercel.app/print-files/jellyfish.png",
      "width": 3000,
      "height": 3000,
      "sha256": "a4ddd966e389639dc1acf665da8c56ed44c8b61bc393a980698736525423069b"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Kiss Cut Stickers (3″×3″in)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "puffer-kiss-cut-stickers-358": {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-kiss-cut-stickers-358",
    "name": "PUFFER KISS-CUT STICKERS",
    "productId": 358,
    "productName": "Kiss-Cut Stickers",
    "variantId": 10163,
    "color": "White",
    "size": "3″×3″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/puffer.png",
      "url": "https://paralyze-area.vercel.app/print-files/puffer.png",
      "width": 3000,
      "height": 3000,
      "sha256": "097388571168e0ef38019b9af02f442c951cb17fcfc3411501960178e6458616"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Kiss Cut Stickers (3″×3″in)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  },
  "scorpion-kiss-cut-sticker-sheet-505": {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-kiss-cut-sticker-sheet-505",
    "name": "SCORPION KISS-CUT STICKER SHEET",
    "productId": 505,
    "productName": "Kiss-Cut Sticker Sheet",
    "variantId": 12917,
    "color": "White",
    "size": "5.83″×8.27″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required",
    "revision": 1,
    "status": "blocked",
    "catalogVerified": true,
    "orderReady": false,
    "printArea": null,
    "position": null,
    "printFile": {
      "path": "/print-files/scorpion-main.png",
      "url": "https://paralyze-area.vercel.app/print-files/scorpion-main.png",
      "width": 3000,
      "height": 2409,
      "sha256": "6dfb4f61c2d09749bfb190ea9b84830d866de298565ae183d0ef60dbbb1673e5"
    },
    "mockup": null,
    "error": "PRINTFUL_OAUTH_TOKEN is unavailable in GitHub Actions; print-area and mockup APIs require authentication. Account-level tokens also require PRINTFUL_STORE_ID.",
    "variantName": "Kiss cut sticker sheet (White / 5.83″×8.27″)",
    "availability": [
      {
        "region": "US",
        "status": "in_stock"
      },
      {
        "region": "EU",
        "status": "in_stock"
      },
      {
        "region": "EU_LV",
        "status": "in_stock"
      },
      {
        "region": "CA",
        "status": "in_stock"
      },
      {
        "region": "UK",
        "status": "in_stock"
      },
      {
        "region": "JP",
        "status": "in_stock"
      },
      {
        "region": "AU",
        "status": "in_stock"
      }
    ]
  }
};
export const AVAILABLE_PRODUCT_PHOTOS = [
  "/products/concept/jellyfish-hem-tee.webp",
  "/products/concept/jellyfish-tote-concept.webp",
  "/products/concept/puffer-mug.webp",
  "/products/concept/scorpion-back-tee.webp",
  "/products/concept/scorpion-chest-hoodie-concept.webp",
  "/products/concept/scorpion-chest-tee.webp",
  "/products/concept/snake-back-tee.webp",
  "/products/concept/snake-chest-tee.webp",
  "/products/concept/snake-notebook-concept.webp",
  "/products/concept/snake-tumbler.webp",
  "/products/pseudo/jellyfish-hem-tee.jpg",
  "/products/pseudo/puffer-mug.jpg",
  "/products/pseudo/scorpion-back-tee.jpg",
  "/products/pseudo/scorpion-chest-tee.jpg",
  "/products/pseudo/snake-back-tee.jpg",
  "/products/pseudo/snake-chest-tee.jpg",
  "/products/pseudo/snake-tumbler.jpg",
  "/products/puffer-mug-real.webp",
  "/products/scorpion-chest-real.webp"
];
